<!--  -->
<template>
  <div class="hwawerq">
    <div style="margin-bottom: 20px;" class="search_box">
      <el-input
        v-model="query.keyword"
        clearable
        style="width:400px;margin-right:10px"
        placeholder="请输入编号或标题"
      />
      <el-select v-model="query.status" placeholder="请选择状态" style="margin-right:10px">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="searchclick"
      >搜索</el-button>
      <el-button
        type="info"
        icon="el-icon-refresh-right"
        @click="rechargeclick"
      >重置</el-button>
      <el-button
        type="warning"
        icon="el-icon-thumb"
        @click="anthall"
      >新增</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="title"
        label="标题"
        width="350"
        align="center"
      />
      <el-table-column
        prop="target_employee_name"
        label="目标员工"
        width="180"
        align="center"
      />
      <el-table-column
        prop="target_employee_no"
        label="目标员工编号"
        width="300"
        align="center"
      />
      <el-table-column
        prop="status_text"
        label="发送状态"
        width="300"
        align="center"
      />
      <el-table-column
        prop="admin_name"
        label="管理员"
        width="200"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        width="200"
        align="center"
      />
      <el-table-column
        label="操作"
        align="center"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button
            style="margin-top: 10px;"
            type="success"
            size="mini"
            fixed="right"
            @click="edit(scope.row)"
          >
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :page-sizes="[10]"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { strategymaterialTaskindex } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        keyword: '',
        status: null
      },
      tableData: [],
      total: null,
      options: [
        {
          value: 1,
          label: '未发送'
        }, {
          value: 2,
          label: '已发送'
        }, {
          value: 3,
          label: '已失效'
        }
      ],
      loading: false
    }
  },
  created() {
    this.list()
  },
  mounted() {

  },
  activated() {
    this.list()
  },
  methods: {
    list() {
      this.loading = true
      strategymaterialTaskindex(this.query).then((res) => {
        console.log('res', res)
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
      })
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keyword = ''
      this.query.status = null
      this.list()
    },
    anthall() {
      this.$router.push({
        path: '/awaitingMaterialMenuadd/index',
        query: {
          type: 1
        }
      })
    },
    edit(item) {
      console.log(item)
      this.$router.push({
        path: '/awaitingMaterialMenuadd/index',
        query: {
          type: 2,
          item: item
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.hwawerq{
  padding: 30px;
}
</style>
